import React from 'react';

const YoukuEmbed = ({ videoId, width = '640px', height = '360px' }) => {
  return (
    <iframe
      width={width}
      height={height}
      src={`https://player.youku.com/embed/${videoId}`}
      allowFullScreen
      title="Youku Video Player"
    ></iframe>
  );
};

export default YoukuEmbed;
